<template>
  <div class="match-card match-card__no-more-coins text-center">
    <div class="match-card__desc">
      <div class="title title--large title--white">
        {{ trans.get('pages:match_game.no_more_coins.header') }}
      </div>

      <div class="desc desc--white my-1">
        {{ trans.get('pages:match_game.no_more_coins.slogan') }}
      </div>
    </div>
    <div class="match-card__image" v-if="avatars.length">
      <div class="avatar-triple">
        <div class="avatar-triple__image" :style="{'background-image':'url(' + avatars[0] + '?h=100)'}">
        </div>
        <div class="avatar-triple__image" :style="{'background-image':'url(' + avatars[1] + '?h=200)'}">
        </div>
        <div class="avatar-triple__image" :style="{'background-image':'url(' + avatars[2] + '?h=100)'}">
        </div>
      </div>
    </div>
    <div class="match-card__button">
      <router-link :to="{name: 'payment', params: {unit: 'credits'}}" class="button button__outline button__outline--white-hov-purple">
        {{ trans.get('pages:match_game.no_more_coins.show_payment_button') }}
      </router-link>

      <!--            <a :href="zRoute('front.more_settings.payment', 'credits')" class="button button__outline button__outline&#45;&#45;white-hov-purple">-->
      <!--                {{ trans.get('pages:match_game.no_more_coins.show_payment_button') }}-->
      <!--            </a>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoMoreCoinsCard',
  props: {
    current: Object,
  },
  data() {
    return {};
  },
  computed: {
    avatars: function () {
      return this.$store.getters['homeProfiles/getRandomAvatars'];
    }
  },
  methods: {},
  mounted() {

  }
};
</script>


